(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/unit-combined.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/unit-combined.js');
"use strict";


const engineUtils = svs.racing.gameEngine.utils.engine;
const systemTypes = svs.racing.common.constants.systemTypes;
const getAutomaticReserve = participants => participants.reduce((prev, curr) => prev.oddsLatest < curr.oddsLatest ? prev : curr, {});
const rowToPositions = (row, numPositions, conditionFn, systemType) => {
  let positions = numPositions > 0 ? new Array(numPositions) : [];
  row.forEach((value, index) => {
    if (engineUtils.isPosition(value) && (conditionFn ? conditionFn(value) : true)) {
      positions[engineUtils.positionToIndex(value)] = engineUtils.indexToPosition(index);
    }
  });

  for (let i = 0; i < positions.length; i++) {
    positions[i] = positions[i] || undefined;
  }
  if (systemType === systemTypes.UNIT_COMBINED_UNORDERED) {
    positions = positions.filter(value => value !== undefined);

    if (positions.length < numPositions) {
      const numPadding = numPositions - positions.length;
      for (let i = 0; i < numPadding; i++) {
        positions.push(undefined);
      }
    }
  }
  return positions;
};
const getNextPosition = row => {
  let nextPosition = 1;
  while (row.indexOf(nextPosition) !== -1) {
    nextPosition++;
  }
  return nextPosition;
};
svs.racing.gameEngine.utils.unitCombined = {
  getAutomaticReserve,
  getNextPosition,
  rowToPositions
};

 })(window);